module.exports = __webpack_public_path__ + "static/media/While She Smiled.fe9d1a49.jpg";